
import { Component, Watch, Mixins } from 'vue-property-decorator';
import TopNavBar from '@/components/app/TopNavBar.vue';
import { HistoryData } from '@/types/history';
import { DeviceInfo } from '@/types/device-info';
import { State } from 'vuex-class';
import LoadableMixin from '@/mixins/LoadableMixin';
import PaginatedMixin from '@/mixins/PaginatedMixin';
import api from '@/modules/api';
import VTable from '@/components/table/Table.vue';
import CreateDevicesGroupModel from '@/components/devices/popups/CreateDevicesGroupModel.vue';
import dayjs from 'dayjs';
import { mutations } from '@/store/types';
import * as dlg from '@/modules/dlg';

@Component({
    components: {
        TopNavBar,
        VTable,
        CreateDevicesGroupModel,
    },
    mixins: [LoadableMixin],
})
export default class GroupDevices extends Mixins<LoadableMixin, PaginatedMixin<any>>(LoadableMixin, PaginatedMixin) {

    locations: HistoryData[] = [];
    searchDevices: DeviceInfo[] = [];
    selectedDevices: DeviceInfo[] = [];
    editDetails: any = {};
    title = 'Create'

    groupDevicesModel = false;

    @State('loading')
    readonly loading!: boolean;

    @State('devices')
    devices!: DeviceInfo[];

    @State('groups')
    groups!: any[];

    headers = [
        { text: 'Name', value: 'name' },
        { text: 'Devices', value: 'totalDevices' },
        { text: 'Created At', value: 'createdAt' },
        { text: 'Action', value: 'action' },
    ];

    slots = [
        {
            name: 'item.totalDevices',
            template: ({ item }: { item: any }) => item?.devices?.length,
        },
        {
            name: 'item.createdAt',
            template: ({ item }: { item: any }) => dayjs(item?.createdAt).format('DD/MM/YYYY'),
        },
        {
            name: 'item.action',
            onClick: ({ item, action }: { item: any, action: string }) => this.onDeleteDeviceGroup(item, action),
        }
    ];

    protected async fetch() {
        this.load(async () => {
            const paginated = await api.getDeviceGroups({
                page: this.pagination.page,
                perPage: this.pagination.perPage,
                filter: this.pagination.filter,
            });
            this.updatePagination(paginated);
        }, 'Unable to load Device Groups');
    }

    @Watch('devices', { immediate: true })
    onDevicesChange(current: DeviceInfo[] | []) {
        this.searchDevices = current;
    }

    @Watch('selectedDevices', { immediate: true, deep: true })
    onSelectDevicesChange() {
        this.fetch();
    }

    handleTableChange(options: any) {
        const { page, itemsPerPage } = options;
        this.pagination = {
            ...this.pagination,
            page,
            perPage: itemsPerPage,
        };

        this.fetch();
    }

    HandleRefresh() {
        this.pagination = {
            ...this.pagination,
            page: 1,
            total: 0,
            hasNext: false,
            hasPrev: false,
            lastPage: 1,
            next: 0,
            prev: 0,
        };
        this.fetch();
    }

    handleTableSearch(filter: string) {
        this.pagination = {
            ...this.pagination,
            page: 1,
            total: 0,
            hasNext: false,
            hasPrev: false,
            lastPage: 1,
            next: 0,
            prev: 0,
            filter,
        };
        this.fetch();
    }

    onNewClick() {
        this.groupDevicesModel = true;
        this.title = 'Create'
    }

    onRowClick(group: any) {
        this.$router.push({ name: 'group-device', params: { groupId: group._id, filter: this.pagination.filter } });
    }

    async onDeleteDeviceGroup(group: any, action: string) {
        if (action === 'Delete') {
            const confirmed = await dlg.confirm("Are you sure you want to delete this group?", 'Delete');
            if (!confirmed) return;
            try {
                this.load(
                    async () => {
                        await api.deleteDeviceGroup(group._id)
                        this.$store.commit(mutations.SET_GROUPS, { groups: this.groups.filter((item: any) => item._id !== group._id) });
                        this.fetch();

                    },
                );
            } catch (error) {
                console.log(error);
            }
        } else if(action === 'Edit') {
            this.$router.push({ name: 'edit-group-device', params: { groupId: group._id } });
        }
    }
}
